import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = { class: "parsed-count" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = ["disabled"]

import { computed, ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'BulkInviteDialog',
  props: {
    open: { type: Boolean },
    eventId: { type: Function }
  },
  emits: ["close", "done"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const rawInput = ref('');
const message = ref('');
const busy = ref(false);

const parsedUserPks = computed((): string[] => {
    return rawInput.value
        .split(/[\n,]+/)
        .map((s: string) => s.trim())
        .filter((s: string) => s.length > 0);
});

const parsedCount = computed((): number => parsedUserPks.value.length);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/events/${props.eventId()}/bulk-invite/`,
            data: { user_pks: parsedUserPks.value, message: message.value },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", {
    open: _ctx.open,
    class: "action-dialog"
  }, [
    _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Массовые приглашения", -1)),
    _createElementVNode("label", null, [
      _cache[3] || (_cache[3] = _createTextVNode("UUID пользователей (по одному на строку или через запятую) ")),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rawInput).value = $event)),
        rows: "6",
        placeholder: "uuid1\nuuid2\n..."
      }, null, 512), [
        [_vModelText, rawInput.value]
      ])
    ]),
    _createElementVNode("p", _hoisted_2, "Распознано: " + _toDisplayString(parsedCount.value) + " пользователь(ей)", 1),
    _createElementVNode("label", null, [
      _cache[4] || (_cache[4] = _createTextVNode("Сообщение (необязательно) ")),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message).value = $event)),
        rows: "3"
      }, null, 512), [
        [_vModelText, message.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn--primary",
        disabled: busy.value || parsedCount.value === 0,
        onClick: submit
      }, _toDisplayString(busy.value ? 'Отправляю…' : `Отправить ${parsedCount.value} приглашений`), 9, _hoisted_4),
      _createElementVNode("button", {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, "Назад")
    ])
  ], 8, _hoisted_1))
}
}

})